import {formAPI} from "../api/api";
import {MyFormValues} from "../components/Form/Form";

const LOAD_FORM_DATA: string = 'LOAD-FORM-DATA';
const LOAD_PURCHASE_DATA: string = 'LOAD-PURCHASE-DATA';
const ADD_ERROR: string = 'ADD-ERROR';

let initialState = {
    data: {
        purchaseId: "",
        subjectPurchase: "",
        personalNumberPurchase: "",
        counterparts: {
            name: "",
            UNP: "",
            FIO: "",
            email: "",
            phone: 0
        },
        files: []
    },
    error: false,
    success: true

};

type Action = {
    type: string;
    data?: MyFormValues
    error?: boolean;
    success?: boolean;
};

const formReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case LOAD_FORM_DATA: {
            return {
                ...state, data: {...action.data}
            }
        }
        case LOAD_PURCHASE_DATA: {
            return {
                ...state, data: {...action.data}
            }
        }
        case ADD_ERROR: {
            return {
                ...state, error: action.error
            }
        }
        default:
            return state;
    }
};

export const loadFormData = (data: object) => {
    return {type: LOAD_FORM_DATA, data: data}
};

const loadPurchaseData = (data: object) => {
    return {type: LOAD_PURCHASE_DATA, data: data}
};

const addError = () => {
    return {type: ADD_ERROR, error: true}
};

export const loadForm = (data: MyFormValues, id: string) => {
    return  (dispatch: any) => {
        formAPI.postFormData(data, id).then(data => {
            if (data && data.status === 200) {
                return dispatch(loadFormData(data.data))
            }
        });
    }
};

export const loadPurchase = (id: string, hash: string) => {
    return (dispatch: any) => {
        formAPI.getPurchaseData(id, hash).then(data => {
            if (data && data.status === 200) {
                return dispatch(loadPurchaseData(data.data))
            } else return dispatch(addError());
        });
    }
};

export default formReducer;